module.exports = __webpack_public_path__ + "static/media/harddrive.711155d2.svg";